module.exports = __webpack_public_path__ + "media/images/social-icon-2-2634ba42c496c69040a53f07ff9b133a.png";